import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ovni from "../images/clients/ovni.jpeg";
import kws from "../images/clients/kws.png";
import geps from "../images/clients/geps.png";
import protergia from "../images/clients/protergia.png";
import nafo from "../images/clients/nafo.png";
import khuza from "../images/clients/khuza.png";
import utech from "../images/clients/utech.jpeg";

const logos = [
  { id: 1, logo: ovni, name: "OVNI" },
  { id: 2, logo: kws, name: "KWS" },
  { id: 3, logo: utech, name: "UTECH" },
  { id: 4, logo: protergia, name: "Protergia" },
  { id: 5, logo: geps, name: "GEPS" },
  { id: 6, logo: nafo, name: "NAFO" },
  { id: 7, logo: khuza, name: "Khuza" },
];

const containerVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Clients = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-white py-28">
      {/* Ambient highlight */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-[-160px] h-[460px] w-[460px] -translate-x-1/2 rounded-full bg-slate-200/40 blur-[160px]" />
      </div>

      <motion.div
        className="relative mx-auto max-w-7xl px-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
      >
        {/* Heading */}
        <div className="mb-14 text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-blue-900 sm:text-4xl">
            {t('clients.heading')}
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative">
          {/* Edge fades */}
          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-36 bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-36 bg-gradient-to-l from-white to-transparent" />

          {/* Floating rail */}
          <div className="relative overflow-hidden rounded-[28px]">
            <div className="relative bg-white/70 backdrop-blur-xl">
              <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-slate-200/60" />
              <div className="pointer-events-none absolute inset-0 rounded-[28px] bg-gradient-to-b from-white/70 to-transparent" />

              {/* Track */}
              <div className="flex w-max items-center gap-24 px-20 py-16 animate-logo-float hover:[animation-play-state:paused]">
                {[...logos, ...logos].map((item, index) => (
                  <motion.div
                    key={`${item.id}-${index}`}
                    className="flex h-16 w-52 items-center justify-center"
                    whileHover={{
                      y: -4,
                      scale: 1.06,
                    }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                    }}
                  >
                    <img
                      src={item.logo}
                      alt={item.name}
                      className="max-h-14 w-auto object-contain"
                      draggable={false}
                    />
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      <style jsx>{`
        @keyframes logo-float {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-logo-float {
          animation: logo-float 42s linear infinite;
        }
        @media (max-width: 640px) {
          .animate-logo-float { animation-duration: 28s; }
        }
      `}</style>
    </section>
  );
};

export default Clients;